import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-bar-right', 'IconArrowBarRight', [
  ['path', { d: 'M20 12l-10 0', key: 'svg-0' }],
  ['path', { d: 'M20 12l-4 4', key: 'svg-1' }],
  ['path', { d: 'M20 12l-4 -4', key: 'svg-2' }],
  ['path', { d: 'M4 4l0 16', key: 'svg-3' }],
]);
